import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getCheckboxGroupWidgetStyles = function getCheckboxGroupWidgetStyles(direction) {
  if (direction === void 0) {
    direction = 'row';
  }
  return StyleSheet.create({
    container: {
      display: 'flex'
    },
    title: {
      marginBottom: tokens.spacing.SPACING_8
    },
    checkboxButtons: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }, direction === 'column' && {
      flexDirection: 'column'
    }),
    checkbox: Object.assign({
      marginRight: tokens.spacing.SPACING_16
    }, direction === 'column' && {
      marginBottom: tokens.spacing.SPACING_16,
      marginRight: tokens.spacing.SPACING_0
    }),
    checkboxFlex: Object.assign(Object.assign({}, direction === 'row' && {
      flex: 1
    }), {
      alignItems: 'flex-start'
    })
  });
};